export default "__VITE_ASSET__f65a92af__"